import { Color } from "@dotlegal/dotlegal-ui-components";

// Mirrors the backend Core.Enums.RiskTreatmentType — the single decision axis for how a risk is treated.
// Transfer is reserved for a later iteration and is not surfaced in the UI yet.
export enum RiskTreatmentType {
    None = 0,
    Mitigate = 1,
    Accept = 2,
    Avoid = 3,
    Transfer = 4,
}

// The treatment-type chip label + colour for the Treatment column. None/Transfer are never rendered
// (None shows nothing; Transfer is not surfaced yet) but are mapped to keep the record total.
export const treatmentChipTranslationKey: Record<RiskTreatmentType, string> = {
    [RiskTreatmentType.None]: "",
    [RiskTreatmentType.Mitigate]: "riskTreatmentMitigating",
    [RiskTreatmentType.Accept]: "riskMitigationStatusRiskAccepted",
    [RiskTreatmentType.Avoid]: "riskTreatmentAvoided",
    [RiskTreatmentType.Transfer]: "",
};

export const treatmentChipColor: Record<RiskTreatmentType, Color> = {
    [RiskTreatmentType.None]: Color.graniteGray,
    [RiskTreatmentType.Mitigate]: Color.darkBlue,
    [RiskTreatmentType.Accept]: Color.gold,
    [RiskTreatmentType.Avoid]: Color.graniteGray,
    [RiskTreatmentType.Transfer]: Color.graniteGray,
};
